module.exports = __webpack_public_path__ + "assets/24ae1c11feb0531fe783f5494e3d155b.mp3";